module.exports = __webpack_public_path__ + "src/assets/img/guestlist_one_double3.3a7d229b.jpg";